import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Collapse,
} from '@mui/material';

interface CollapsibleGroupProps {
  label: string;
  isExpanded: boolean;
  hasValues: boolean;
  onToggle: (expanded: boolean) => void;
  onClear?: () => void;
  children: React.ReactNode;
  backgroundColor?: string;
  borderColor?: string;
}

export const CollapsibleGroup: React.FC<CollapsibleGroupProps> = ({
  label,
  isExpanded,
  hasValues,
  onToggle,
  onClear,
  children,
  backgroundColor = 'background.secondary',
  borderColor,
}) => {
  const handleCheckboxChange = (checked: boolean) => {
    if (!checked && hasValues && onClear) {
      // User is unchecking when there are values - clear them
      onClear();
    }
    onToggle(checked);
  };

  return (
    <Box
      sx={{
        backgroundColor,
        paddingX: 2,
        paddingY: 1,
        ...(borderColor && {
          border: '1px dashed',
          borderColor,
        }),
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={hasValues || isExpanded}
            indeterminate={!hasValues && isExpanded}
            onChange={(e) => handleCheckboxChange(e.target.checked)}
          />
        }
        label={label}
      />
      <Collapse in={isExpanded}>
        <Box sx={{ pl: 2 }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};
